export default function getPriceTiers(data) {
    return data?.price_tiers || [];
}
//# sourceMappingURL=getPriceTiers.js.map